<template lang='pug'>
div
  b-modal(:active="isModalOpened", has-modal-card)
    .modal-card
      .modal-card-head
        p.modal-card-title Edit Collection
      .modal-card-body
        b-field(label="Collection name")
          b-input(
            placeholder="Insert collection name here",
            v-model="newCollectionName"
          )
        b-field(label="Sharing usernames")
          b-input(
            placeholder="Insert usernames here.",
            type="textarea",
            v-model="rawSharingUsers"
          )
      .modal-card-foot
        .container
          .level
            .level-left
              .level-item
                b-button(type="is-primary", @click="uiShareCollection") Update
                b-button(type="is-danger", @click="closeModal") Cancel
            .level-right
              .level-item
                b-button(
                  type="is-danger",
                  @click="uiDeleteCollection",
                  icon-left="trash-alt"
                ) Delete Collection
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    originalRawSharingUsers: "",
    rawSharingUsers: "",
    newCollectionName: "",
  }),
  watch: {
    isModalOpened() {
      this.newCollectionName = this.selectedCollectionName;
      this.rawSharingUsers = this.selectedCollectionSharingUsers.join(", ");
      this.originalRawSharingUsers = this.rawSharingUsers;
    },
  },
  computed: {
    ...mapState("shareCollection", {
      isModalOpened: (s) => s.isModalOpened,
    }),
    ...mapState("collection", {
      selectedCollectionId: (s) => s.selectedCollectionId,
    }),
    ...mapGetters("collection", [
      "selectedCollectionSharingUsers",
      "selectedCollectionName",
    ]),
  },
  methods: {
    ...mapMutations("shareCollection", ["closeModal"]),
    ...mapMutations('collection', ['setSelectedCollectionId']),
    ...mapActions("shareCollection", ["shareCollection", "renameCollection", 'deleteCollection']),
    ...mapActions('collection', ['fetchCollections']),
    //also check renaming coll
    async uiShareCollection() {

      let shouldFetchCollections = false

      if (this.newCollectionName !== this.selectedCollectionName) {
        //call change name api
        const reqBody = {
          collectionId: this.selectedCollectionId,
          newName: this.newCollectionName,
        };
        const resp = await this.renameCollection(reqBody);
        if (resp.status === 'success'){
          this.openSuccessSnackbar('Collection is renamed')
          shouldFetchCollections = true
        }
        else if (resp.status !== "success") {
          this.openErrorSnackbar(
            resp.message ? resp.message : "Renaming error! Please try again later"
          );
          return
        }
      }

      if (this.originalRawSharingUsers !== this.rawSharingUsers) {
        //extract sharing users
        const sharingUsers = this.rawSharingUsers
          .split(",")
          .map((x) => x.trim());
        const reqBody = {
          collectionId: this.selectedCollectionId,
          sharingUsers,
        };
        const resp = await this.shareCollection(reqBody);
        if (resp.status === "success") {
          this.openSuccessSnackbar("Your collection is shared");
          shouldFetchCollections = true
        } else {
          this.openErrorSnackbar(
            resp.message ? resp.message : "Sharing error! Please try again later"
          );
        }
      }

      if(shouldFetchCollections){
        await this.fetchCollections()
        this.closeModal()
      }
    },
    async uiDeleteCollection(){
      const confirmCallback = async () =>{
        const reqBody = {
          collectionId : this.selectedCollectionId
        }
        const resp = await this.deleteCollection(reqBody)
        if (resp.status === 'success'){
          this.openSuccessSnackbar('Collection is deleted')
          await this.fetchCollections()
          this.setSelectedCollectionId(null)
          this.closeModal()
        }
        else if (resp.status !== "success") {
          this.openErrorSnackbar(
            resp.message ?? "Deletion error! Please try again later"
          );
          this.closeModal()
        }
      }

      this.openDangerConfirmMessageBox(
        'Are you sure to delete this collection?',
        confirmCallback
      )
    }
  },
};
</script>